const TagReducer=(state,action)=>{
    switch(action.type){  
   
        // {
        //     id:""
        //     name:""
        // }
        
        //tag added
        case 'ADD_TO_TAG' :{
              return {...state,tagList : [ ...state.tagList , action.payload] }
        } 
        //note edit
        case 'EDIT_TAG':{
            return {...state,tagList : state.tagList.map((item)=>{
                  if(item.id===action.payload.id){
                     return action.payload
                  }else{
                     return item
                  }
            }) }
        } 
        //note deleted
        case 'DELETE_TAG' :{
            return {...state,tagList : state.tagList.filter((item)=>item.id !== action.payload.id) }
        }
        
        default :
        return state
    }
}

export default TagReducer;